import { issuanceList, issuanceEligibleTrainees, userCertificatesBatch } from "constants/issuance";
import * as api from "../API/index";
import { authorizedUser } from "components/CommonComponents/CommonFunctions";

export const getIssuanceList = async (dispatch, pageNum, filters) => {
  try {
    const res = await api.get_issuance_list(pageNum, filters);
    dispatch({ type: issuanceList, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: issuanceList,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const getIssuanceEligibleTrainees = async (dispatch, id, page1, page2, filters) => {
  try {
    const res = await api.get_issuance_eligible_trainees(id, page1, page2, filters);
    dispatch({ type: issuanceEligibleTrainees, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: issuanceEligibleTrainees,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};

export const generateUserCertificate = async (batchId, bodyData) => {
  try {
    const res = await api.generate_user_certificate(batchId, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const getUserCertificatesByBatch = async (dispatch, batchId, pageNum, filters) => {
  try {
    const res = await api.get_user_certificates_by_batch(batchId, pageNum, filters);
    dispatch({ type: userCertificatesBatch, payload: res.data });
  } catch (error) {
    authorizedUser(error?.response?.data);
    dispatch({
      type: userCertificatesBatch,
      payload: error?.response?.data ?? { message: error?.message },
    });
  }
};
